module.exports = __webpack_public_path__ + "img/info.005.f1241d13.jpeg";